<template>
  <div class="chat-main">
    <!-- <div class="hidden-detail" @click="close">
      <i class="el-icon-close"></i>
    </div>-->
    <el-button
      @click="close"
      type="text"
      class="newBackBtn"
      icon="el-icon-arrow-left"
    >
      返回
    </el-button>
    <div class="clearfix"></div>
    <div class="title" style="text-align: left">聊天记录</div>
    <div>
      <div
        v-for="(item, index) in data.formData"
        :key="index"
        class="chat-item"
      >
        <div class="chat-item-title">
          <div class="title">
            {{ item.direct == 1 ? item.userName : item.patientName }}
          </div>
          <div class="time">{{ new Date(item.createDt).toLocaleString() }}</div>
        </div>
        <div class="content">
          <template v-if="item.type === 'text'">{{ item.content }}</template>
          <template v-else-if="item.type === 'img'">
            <img :src="item.url" alt="" />
          </template>
          <template v-else-if="item.type === 'template'">
            <div v-html="item.content"></div>
          </template>
          <template v-else>暂无记录</template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'chatRecord',
  props: {
    data: {
      type: Object,
      default: {
        formData: [],
        detailLimit: [
          {
            label: '发单企业',
            prop: 'customerName'
          },
          {
            label: '项目名称',
            prop: 'customerName'
          },
          {
            label: '药店',
            prop: 'customerName'
          },
          {
            label: '巡店时间',
            prop: 'customerName'
          },
          {
            label: '药店定位',
            prop: 'customerName'
          },
          {
            label: '产品名称',
            prop: 'customerName'
          },
          {
            label: '全国指导价',
            prop: 'customerName'
          },
          {
            label: '产品售价',
            prop: 'customerName'
          },
          {
            label: '陈列要求',
            prop: 'customerName'
          },
          {
            label: '陈列状态',
            prop: 'customerName'
          },
          {
            label: '陈列照片',
            prop: 'customerName',
            img: true
          }
        ]
      }
    }
  },
  methods: {
    close() {
      this.$router.back();
      // this.$parent.hideDetail()
      this.$parent.hideDetail();
    },
    handleFiles(str) {
      let list = [];
      if (!str || !this.data.formData.bingliFileName) {
        return list;
      }
      let nameList = this.data.formData.bingliFileName.split(',');
      let strList = str.split(',');
      for (let i = 0; i < strList.length; i++) {
        list.push({ src: strList[i], name: nameList[i] });
      }
      return list;
    },

    eventClose() {
      // 关闭窗口
      this.$emit('update:showUserAddEdit', false); // 逆向修改
    }
    //提交
  },
  created() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }
};
</script>

<style lang="scss" scoped>
.hidden-detail {
  float: right;
  width: 1em;
  font-size: 25px;
  height: 2em;
}
.chat-main > .title {
  font-weight: 500;
  font-size: large;
  text-align: left;
  box-shadow: 0 2px 1px #d1d1d159;
  margin-bottom: 20px;
}
.chat-item {
  text-align: left;
  .content {
    padding: 20px 0;
    & > img {
      width: 300px;
      height: auto;
    }
  }
  .chat-item-title {
    & > div {
      display: inline-block;
    }
    .title {
      font-weight: bold;
      text-align: left;
    }
  }
}
</style>
